/**
 * @generated SignedSource<<cc7025d71681eeb21bd6af4c3461acdf>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type PlanBillingPeriod = "ANNUALLY" | "BI_ANNUALLY" | "MONTHLY";
export type PricingVersion = "VERSION_1" | "VERSION_2";
export type upgradeDialogQuery$variables = Record<PropertyKey, never>;
export type upgradeDialogQuery$data = {
  readonly ecommerceSettings: {
    readonly ecommerceName: ECommerce;
  } | null;
  readonly planForUpgradeSeller: {
    readonly name: string;
    readonly planID: number;
    readonly planPeriod: PlanBillingPeriod;
    readonly price: number;
    readonly trialPeriod: number;
    readonly version: PricingVersion;
  } | null;
  readonly plansForSeller: ReadonlyArray<{
    readonly plans: ReadonlyArray<{
      readonly sellerID: number | null;
    } | null>;
  }>;
  readonly subscription: {
    readonly plan: {
      readonly isCustom: boolean;
    } | null;
  } | null;
};
export type upgradeDialogQuery = {
  response: upgradeDialogQuery$data;
  variables: upgradeDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planPeriod",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trialPeriod",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustom",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "upgradeDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "planForUpgradeSeller",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlanGraphql",
            "kind": "LinkedField",
            "name": "plan",
            "plural": false,
            "selections": [
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlanTier",
        "kind": "LinkedField",
        "name": "plansForSeller",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "plans",
            "plural": true,
            "selections": [
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "upgradeDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "planForUpgradeSeller",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlanGraphql",
            "kind": "LinkedField",
            "name": "plan",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v9/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettings",
        "plural": false,
        "selections": [
          (v7/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlanTier",
        "kind": "LinkedField",
        "name": "plansForSeller",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "plans",
            "plural": true,
            "selections": [
              (v8/*:: as any*/),
              (v9/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f784484b52821ce6ebd757703075ee7",
    "id": null,
    "metadata": {},
    "name": "upgradeDialogQuery",
    "operationKind": "query",
    "text": "query upgradeDialogQuery {\n  planForUpgradeSeller {\n    planID\n    name\n    price\n    planPeriod\n    trialPeriod\n    version\n    id\n  }\n  subscription {\n    plan {\n      isCustom\n      id\n    }\n    id\n  }\n  ecommerceSettings {\n    ecommerceName\n    id\n  }\n  plansForSeller {\n    plans {\n      sellerID\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60983c076d8940c52794f5698e00af2b";

export default node;
